module.exports = __webpack_public_path__ + "img/MTW.7dff8938.svg";